/* CheekyGlo buy box: quantity breaks + sticky add to cart for vso-product-info-07.
   Tier codes are applied to the cart just before the add, so the discount only
   ever comes from this template. Bundles can mix colours, one slot per glove. */
(function () {
  function formatMoney(cents, format) {
    var value = (Number(cents) || 0) / 100;
    return (format || '${{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      var fixed = key.indexOf('no_decimals') > -1 ? Math.round(value).toString() : value.toFixed(2);
      var parts = fixed.split('.');
      var sep = key.indexOf('comma_separator') > -1 ? '.' : ',';
      var dec = key.indexOf('comma_separator') > -1 ? ',' : '.';
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep);
      if (key.indexOf('apostrophe') > -1) parts[0] = parts[0].replace(/,/g, "'");
      return parts.join(dec);
    });
  }

  function withTimeout(promise, ms) {
    return Promise.race([promise, new Promise(function (resolve) { setTimeout(resolve, ms); })]);
  }

  // "Sensitive (White)" reads as "White" in the tight spots.
  function shortName(title) {
    var m = /\(([^)]+)\)/.exec(title || '');
    return m ? m[1] : title;
  }

  function init(qb) {
    if (qb.__cgppInit) return;
    qb.__cgppInit = true;

    var section = qb.closest('.shopify-section') || document;
    var moneyFormat = qb.getAttribute('data-money-format');
    var unitLabel = qb.getAttribute('data-unit') || 'each';
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var variants = [];
    try { variants = JSON.parse(qb.querySelector('[data-cgpp-variants]').textContent) || []; } catch (e) {}

    var inputs = Array.prototype.slice.call(qb.querySelectorAll('input[data-cgpp-tier]'));
    var tierCodes = inputs.map(function (i) { return (i.getAttribute('data-code') || '').trim(); }).filter(Boolean);
    var errorNode = qb.querySelector('[data-cgpp-error]');

    var sticky = qb.querySelector('[data-cgpp-sticky]');
    var stickySelect = sticky && sticky.querySelector('[data-cgpp-sticky-select]');
    var stickyTitle = sticky && sticky.querySelector('[data-cgpp-sticky-title]');
    var stickySub = sticky && sticky.querySelector('[data-cgpp-sticky-sub]');
    var stickyAdd = sticky && sticky.querySelector('[data-cgpp-sticky-add]');

    // The bar is fixed, so lift it out of the section to avoid transformed ancestors.
    if (sticky) {
      document.querySelectorAll('body > .cgpp-sticky').forEach(function (old) { old.remove(); });
      document.body.appendChild(sticky);
      sticky.hidden = false;
      var pad = function () { document.body.style.paddingBottom = sticky.offsetHeight + 'px'; };
      pad();
      window.addEventListener('resize', pad);
    }

    function variantById(id) {
      id = Number(id);
      for (var i = 0; i < variants.length; i++) if (variants[i].id === id) return variants[i];
      return null;
    }

    function currentVariant() {
      var idInput = section.querySelector('[data-vso-variant-id]');
      return (idInput && variantById(idInput.value)) || variants[0] || null;
    }

    function currentInput() {
      for (var i = 0; i < inputs.length; i++) if (inputs[i].checked) return inputs[i];
      return inputs[0];
    }

    function slotsFor(input) {
      return Array.prototype.slice.call(input.closest('.cgpp-tier').querySelectorAll('[data-cgpp-slot]'));
    }

    // Swatch colours come from the main picker so the dots always match it.
    function dotColour(variant) {
      var radios = section.querySelectorAll('[data-vso-option-value]');
      for (var i = 0; i < radios.length; i++) {
        if (radios[i].value !== variant.option1) continue;
        var label = section.querySelector('label[for="' + radios[i].id + '"] .vso-product-info__variant-swatch');
        if (label) return getComputedStyle(label).backgroundColor;
      }
      return '';
    }

    // One variant per glove for the active tier.
    function lineVariants(input) {
      var slots = slotsFor(input);
      var fallback = currentVariant();
      if (!slots.length) {
        var qty = Number(input.getAttribute('data-qty')) || 1;
        var list = [];
        for (var i = 0; i < qty; i++) list.push(fallback);
        return list;
      }
      return slots.map(function (s) { return variantById(s.value) || fallback; });
    }

    function tierMath(input, lines) {
      var pct = Number(input.getAttribute('data-pct')) || 0;
      var full = lines.reduce(function (sum, v) { return sum + v.price; }, 0);
      var total = Math.round(full * (100 - pct) / 100);
      return { qty: lines.length, pct: pct, full: full, total: total, each: Math.round(total / lines.length) };
    }

    function colourSummary(lines) {
      var order = [];
      var counts = {};
      lines.forEach(function (v) {
        var name = shortName(v.title);
        if (!counts[name]) { counts[name] = 0; order.push(name); }
        counts[name]++;
      });
      if (order.length === 1) return order[0];
      return order.map(function (n) { return counts[n] + ' ' + n; }).join(' + ');
    }

    function paintSlots(input) {
      slotsFor(input).forEach(function (s) {
        var v = variantById(s.value);
        if (!v) return;
        var slot = s.closest('.cgpp-mix__slot');
        slot.querySelector('[data-cgpp-name]').textContent = shortName(v.title);
        var colour = dotColour(v);
        if (colour) slot.querySelector('[data-cgpp-dot]').style.setProperty('--cgpp-dot', colour);
      });
    }

    function render() {
      if (!variants.length) return;
      inputs.forEach(function (input) {
        var card = input.closest('.cgpp-tier');
        var m = tierMath(input, lineVariants(input));
        // Per-glove price is the headline; the bundle total sits underneath.
        card.querySelector('[data-cgpp-now]').textContent = formatMoney(m.each, moneyFormat);
        var was = card.querySelector('[data-cgpp-was]');
        was.textContent = formatMoney(Math.round(m.full / m.qty), moneyFormat);
        was.hidden = m.pct <= 0;
        var each = card.querySelector('[data-cgpp-each]');
        each.textContent = formatMoney(m.total, moneyFormat) + ' total';
        each.hidden = m.qty <= 1;
        paintSlots(input);
      });

      var active = currentInput();
      var lines = lineVariants(active);
      var m = tierMath(active, lines);
      var available = lines.every(function (v) { return v.available; });

      section.querySelectorAll('[data-vso-qty-input]').forEach(function (q) { q.value = String(m.qty); });

      // "ADD TO CART | $63.00"
      section.querySelectorAll('[data-vso-atc-price]').forEach(function (node) {
        node.textContent = formatMoney(m.total, moneyFormat);
        node.style.display = available ? '' : 'none';
      });
      section.querySelectorAll('[data-vso-atc-separator]').forEach(function (node) {
        node.style.display = available ? '' : 'none';
      });

      if (sticky) {
        stickySelect.value = active.value;
        stickyTitle.textContent = active.getAttribute('data-label') + (m.pct > 0 ? ' (Save ' + m.pct + '%)' : '');
        stickySub.textContent = colourSummary(lines) + ' · ' + formatMoney(m.total, moneyFormat);
        stickyAdd.disabled = !available;
        stickyAdd.textContent = available ? stickyAdd.getAttribute('data-add') : stickyAdd.getAttribute('data-sold-out');
      }
    }

    function setAllSlots(variantId) {
      qb.querySelectorAll('[data-cgpp-slot]').forEach(function (s) {
        var opt = s.querySelector('option[value="' + variantId + '"]');
        if (opt && !opt.disabled) s.value = String(variantId);
      });
    }

    function showError(message) {
      if (!errorNode) return;
      errorNode.textContent = message || '';
      errorNode.hidden = !message;
    }

    inputs.forEach(function (input) { input.addEventListener('change', render); });
    qb.querySelectorAll('[data-cgpp-slot]').forEach(function (s) { s.addEventListener('change', render); });

    if (stickySelect) {
      stickySelect.addEventListener('change', function () {
        inputs.forEach(function (input) { input.checked = input.value === stickySelect.value; });
        render();
      });
    }

    // The main colour picker sets every glove at once. The section updates the
    // hidden variant id first, then this runs.
    section.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('[data-vso-option-value], [data-vso-option-dropdown]')) {
        var v = currentVariant();
        if (v) setAllSlots(v.id);
        render();
      }
    });

    if (stickyAdd) {
      stickyAdd.addEventListener('click', function () {
        var atc = section.querySelector('[data-vso-atc]');
        if (!atc) return;
        stickyAdd.setAttribute('aria-busy', 'true');
        atc.click();
        setTimeout(function () { stickyAdd.removeAttribute('aria-busy'); }, 1500);
      });
    }

    function applyTierCode(code) {
      if (!code) return Promise.resolve();
      return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var lowerTierCodes = tierCodes.map(function (c) { return c.toLowerCase(); });
          var keep = (cart.discount_codes || [])
            .map(function (d) { return d.code; })
            .filter(function (c) { return lowerTierCodes.indexOf(String(c).toLowerCase()) === -1; });
          keep.push(code);
          return fetch(root + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ discount: keep.join(',') })
          });
        })
        .catch(function () {});
    }

    function addLines(lines) {
      var grouped = [];
      var index = {};
      lines.forEach(function (v) {
        if (index[v.id] === undefined) { index[v.id] = grouped.length; grouped.push({ id: v.id, quantity: 0 }); }
        grouped[index[v.id]].quantity++;
      });
      return fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: grouped })
      }).then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok || data.status) throw data;
          return data;
        });
      });
    }

    // Tells the instant cart drawer (snippets/cg-instant-cart.liquid) what is being
    // added, with the tier discount already taken off, so it can draw it straight away.
    function announceInstantAdd(input, lines) {
      var product = {};
      try { product = JSON.parse(qb.querySelector('[data-cgpp-product]').textContent) || {}; } catch (e) {}
      var pct = Number(input.getAttribute('data-pct')) || 0;
      var grouped = [];
      var index = {};
      lines.forEach(function (v) {
        if (!v) return;
        if (index[v.id] === undefined) {
          index[v.id] = grouped.length;
          grouped.push({ id: v.id, quantity: 0, title: product.title || '', variant_title: product.single ? null : v.title, image: v.image || null, unit: v.price, full_unit: Math.max(v.price, v.compare_at_price || 0) });
        }
        grouped[index[v.id]].quantity++;
      });
      if (!grouped.length) return;
      grouped.forEach(function (g) { g.line_price = Math.round(g.unit * g.quantity * (100 - pct) / 100); });
      document.dispatchEvent(new CustomEvent('cg:instant-add', { detail: { lines: grouped } }));
    }

    // Runs before the section's own add-to-cart handler (capture phase).
    // Single gloves go through the section as normal; bundles are added here
    // so each glove can be its own colour.
    section.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches || !form.matches('form.vso-product-info__form')) return;
      var active = currentInput();
      var lines = lineVariants(active);
      var code = (active.getAttribute('data-code') || '').trim();
      if (form.checkValidity && !form.checkValidity()) return;
      announceInstantAdd(active, lines);
      if (lines.length < 2 && !code) return;

      e.preventDefault();
      e.stopImmediatePropagation();
      showError('');

      var buttons = [e.submitter || form.querySelector('[data-vso-atc]'), stickyAdd].filter(Boolean);
      var wasDisabled = buttons.map(function (b) { return b.disabled; });
      buttons.forEach(function (b) { b.setAttribute('aria-busy', 'true'); b.disabled = true; });

      withTimeout(applyTierCode(code), 4000)
        .then(function () { return addLines(lines); })
        .then(function () {
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: { resource: {}, sourceId: String(lines[0].id), data: { source: 'product-form-component', itemCount: lines.length, variantId: String(lines[0].id) } }
          }));
        })
        .catch(function (err) {
          document.dispatchEvent(new CustomEvent('cg:instant-add-failed'));
          showError((err && (err.description || err.message)) || 'Something went wrong. Please try again.');
        })
        .finally(function () {
          buttons.forEach(function (b, i) { b.removeAttribute('aria-busy'); b.disabled = wasDisabled[i]; });
          render();
        });
    }, true);

    render();
  }

  // The VSO section adds to cart but never tells Stretch, so the drawer stays shut
  // and the count stays stale. Hand Stretch the event it listens for.
  function bridgeToStretchDrawer() {
    if (window.__cgppDrawerBridge) return;
    window.__cgppDrawerBridge = true;
    document.addEventListener('cart:update', function (e) {
      var data = e.detail && e.detail.data;
      if (!data || data.source !== 'product-form-component') return;
      var drawer = document.querySelector('cart-drawer');
      // Once opened, the drawer is moved to <body>, so look for its (now empty) section wrapper.
      var wrap = (drawer && drawer.closest('.shopify-section')) || document.querySelector('[id^="shopify-section-"][id$="cart-drawer"]');
      var sectionId = wrap ? wrap.id.replace('shopify-section-', '') : null;
      if (!sectionId) return;
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      Promise.all([
        fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }),
        fetch(root + '?sections=' + encodeURIComponent(sectionId)).then(function (r) { return r.json(); })
      ]).then(function (res) {
        var cart = res[0];
        cart.sections = res[1];
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
          bubbles: true,
          detail: { baseEvent: 'variant:add', cart: cart }
        }));
      }).catch(function () {});
    });
  }

  // Delivery countdown. Works in warehouse time and skips weekends.
  function initShip(el) {
    if (el.__cgppInit) return;
    el.__cgppInit = true;
    var tz = el.getAttribute('data-tz') || 'Australia/Sydney';
    var cutoff = Number(el.getAttribute('data-cutoff')) || 14;
    var minDays = Number(el.getAttribute('data-min')) || 2;
    var maxDays = Math.max(minDays, Number(el.getAttribute('data-max')) || minDays);
    var line = el.querySelector('[data-cgpp-ship-line]');
    var arrive = el.querySelector('[data-cgpp-ship-arrive]');
    var dayFmt = new Intl.DateTimeFormat('en-AU', { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' });
    var weekdayFmt = new Intl.DateTimeFormat('en-AU', { weekday: 'long', timeZone: 'UTC' });

    function warehouseNow() {
      var parts = {};
      try {
        new Intl.DateTimeFormat('en-US', {
          timeZone: tz, hourCycle: 'h23', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric'
        }).formatToParts(new Date()).forEach(function (p) { parts[p.type] = Number(p.value); });
      } catch (e) { return null; }
      return parts;
    }
    function isWeekend(d) { var w = d.getUTCDay(); return w === 0 || w === 6; }
    function addBusinessDays(d, n) {
      var out = new Date(d.getTime());
      while (n > 0) { out.setUTCDate(out.getUTCDate() + 1); if (!isWeekend(out)) n--; }
      return out;
    }
    function nice(d) { return dayFmt.format(d).replace(',', ''); }
    function fill(tpl, token, html) {
      var safe = document.createElement('span');
      safe.textContent = tpl;
      return safe.innerHTML.replace(token, '<strong>' + html + '</strong>');
    }

    function paint() {
      var p = warehouseNow();
      if (!p) return;
      var today = new Date(Date.UTC(p.year, p.month - 1, p.day));
      var shipToday = !isWeekend(today) && p.hour < cutoff;
      var ship = shipToday ? today : addBusinessDays(today, 1);

      if (shipToday) {
        var left = (cutoff * 60) - (p.hour * 60 + p.minute);
        var h = Math.floor(left / 60);
        var m = left % 60;
        line.innerHTML = fill(el.getAttribute('data-before') || '', '[time]', (h ? h + 'h ' : '') + m + 'm');
      } else {
        var sameWeek = (ship - today) / 864e5 === 1 ? 'tomorrow' : weekdayFmt.format(ship);
        line.innerHTML = fill(el.getAttribute('data-after') || '', '[day]', sameWeek);
      }
      var from = addBusinessDays(ship, minDays);
      var to = addBusinessDays(ship, maxDays);
      var dates = minDays === maxDays ? nice(from) : nice(from) + ' to ' + nice(to);
      arrive.innerHTML = fill(el.getAttribute('data-arrive') || '', '[dates]', dates);
      el.hidden = false;
    }

    paint();
    setInterval(paint, 30000);
  }

  // Buy boxes with the quantity breaks block switched off. The section still adds to cart
  // itself; this opens the instant drawer straight away (snippets/cg-instant-cart.liquid),
  // keeps the Stretch drawer in sync, and adds a sticky add to cart that slides up once the
  // button has been scrolled past. Versio add-on ADD clicks are handled site-wide by
  // snippets/cg-addon-fix.liquid.
  function initPlain(form) {
    if (form.__cgppPlain) return;
    form.__cgppPlain = true;

    var section = form.closest('.shopify-section') || document;
    if (section.querySelector('[data-cgpp-qb]')) return;
    bridgeToStretchDrawer();

    var atc = form.querySelector('[data-vso-atc]');
    var holder = form.closest('[data-product-url]');
    var product = null;

    function sized(src) {
      if (!src) return null;
      if (src.indexOf('//') === 0) src = 'https:' + src;
      return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=192';
    }

    function saleRate() {
      var rate = 1;
      try { rate = Number(sessionStorage.getItem('cg-instant-cart-rate')) || 1; } catch (e) {}
      return rate > 0 && rate <= 1 ? rate : 1;
    }

    function cents(text) {
      var m = /[\d.,]+/.exec(text || '');
      if (!m) return 0;
      var n = parseInt(m[0].replace(/[.,]/g, ''), 10) || 0;
      return /[.,]\d{2}$/.test(m[0]) ? n : n * 100;
    }

    function variantById(id) {
      if (!product) return null;
      for (var i = 0; i < product.variants.length; i++) if (product.variants[i].id === id) return product.variants[i];
      return null;
    }

    function linesFor(id, qty) {
      id = Number(id);
      var v = variantById(id);
      if (v) {
        var single = product.variants.length === 1;
        return [{
          id: id,
          quantity: qty,
          title: product.title,
          variant_title: single ? null : v.title,
          image: sized((v.featured_image && v.featured_image.src) || product.featured_image),
          full_unit: Math.max(v.price, v.compare_at_price || 0), // savings line in the instant cart
          line_price: Math.round(v.price * qty * saleRate())
        }];
      }
      var card = document.querySelector('[data-versio-addon-item][data-variant-id="' + id + '"]');
      if (!card) return null;
      var img = card.querySelector('img');
      var title = card.querySelector('.versio-addon-title');
      var price = card.querySelector('.versio-addon-price');
      return [{
        id: id,
        quantity: qty,
        title: title ? title.textContent.trim() : '',
        variant_title: null,
        image: img ? sized(img.getAttribute('src').replace(/[?&]width=\d+/, '')) : null,
        line_price: Math.round(cents(price && price.textContent) * qty * saleRate())
      }];
    }

    // Runs before the section's own add-to-cart handler (capture phase), which does the add.
    section.addEventListener('submit', function (e) {
      if (e.target !== form) return;
      if (form.checkValidity && !form.checkValidity()) return;
      var submitter = e.submitter || atc;
      if (submitter && (submitter.disabled || submitter.getAttribute('aria-busy') === 'true')) return;
      var data = new FormData(form);
      var idNode = form.querySelector('[data-vso-variant-id]');
      var id = data.get('id') || (idNode && idNode.value);
      if (!id) return;
      var qty = Math.max(1, parseInt(data.get('quantity'), 10) || 1);
      var lines = null;
      try { lines = linesFor(id, qty); } catch (err) {}
      document.dispatchEvent(new CustomEvent('cg:instant-add', { detail: { lines: lines || [] } }));
    }, true);

    if (!atc || document.querySelector('body > .cgpp-sticky')) return;

    var bar = document.createElement('div');
    bar.className = 'cgpp cgpp-sticky cgpp-sticky--scroll';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML =
      '<div class="cgpp-sticky__inner">' +
        '<button type="button" class="cgpp-sticky__pick" data-cgpp-sticky-pick>' +
          '<span class="cgpp-sticky__title"></span><span class="cgpp-sticky__sub"></span>' +
        '</button>' +
        '<button type="button" class="cgpp-sticky__add"></button>' +
      '</div>';
    var pick = bar.querySelector('[data-cgpp-sticky-pick]');
    var barTitle = bar.querySelector('.cgpp-sticky__title');
    var barSub = bar.querySelector('.cgpp-sticky__sub');
    var barAdd = bar.querySelector('.cgpp-sticky__add');
    document.body.appendChild(bar);
    bar.inert = true;

    var pad = function () { document.body.style.paddingBottom = bar.offsetHeight + 'px'; };
    pad();
    window.addEventListener('resize', pad);

    function paint() {
      var idNode = form.querySelector('[data-vso-variant-id]');
      var v = variantById(Number(idNode && idNode.value));
      var priceNode = atc.querySelector('[data-vso-atc-price]');
      var available = !atc.disabled;
      barTitle.textContent = product ? product.title : '';
      barSub.textContent = [
        v && product.variants.length > 1 ? shortName(v.title) : '',
        priceNode ? priceNode.textContent.trim() : ''
      ].filter(Boolean).join(' · ');
      barAdd.disabled = !available;
      barAdd.textContent = available
        ? (atc.getAttribute('data-vso-add-text') || 'Add to cart')
        : (atc.getAttribute('data-vso-sold-out-text') || 'Sold out');
    }

    if (holder && window.fetch) {
      fetch(holder.getAttribute('data-product-url') + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (p) { product = p; paint(); })
        .catch(function () {});
    }
    paint();

    // The section swaps the variant, price and sold-out state in place; follow it.
    new MutationObserver(function () { paint(); }).observe(atc, { attributes: true, childList: true, subtree: true, characterData: true });
    form.addEventListener('change', function () { setTimeout(paint, 0); });

    barAdd.addEventListener('click', function () {
      barAdd.setAttribute('aria-busy', 'true');
      atc.click();
      setTimeout(function () { barAdd.removeAttribute('aria-busy'); }, 1500);
    });
    pick.addEventListener('click', function () {
      atc.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });

    // Only once the real button has gone off the top of the screen.
    var shown = false;
    function toggleBar() {
      var past = atc.getBoundingClientRect().bottom < 0;
      if (past === shown) return;
      shown = past;
      bar.classList.toggle('is-shown', past);
      bar.setAttribute('aria-hidden', past ? 'false' : 'true');
      bar.inert = !past;
    }
    window.addEventListener('scroll', toggleBar, { passive: true });
    window.addEventListener('resize', toggleBar);
    toggleBar();
  }

  function initAll() {
    if (document.querySelector('[data-cgpp-qb]')) bridgeToStretchDrawer();
    document.querySelectorAll('[data-cgpp-qb]').forEach(init);
    document.querySelectorAll('form.vso-product-info__form').forEach(initPlain);
    document.querySelectorAll('[data-cgpp-ship]').forEach(initShip);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
